import ClinicalMenu from "./DisplayMenuItems/ClinicalMenu";
import TreatmentMenu from "./DisplayMenuItems/TreatmentMenu";
import OutcomesMenu from "./DisplayMenuItems/OutcomesMenu";
import EconomicBurdenMenu from "./DisplayMenuItems/EconomicBurdenMenu";
import MiscMenu from "./DisplayMenuItems/MiscMenu";
import EpiMenu from "./DisplayMenuItems/EpiMenu";
import CliSVG from "../icons/ClinicalCharacteristics.svg";
import EpiSVG from "../icons/Epidemiology.svg";
import EcoSVG from "../icons/EconomicBurden.svg";
import MiscSVG from "../icons/Misc.svg";
import OutcomesSVG from "../icons/Outcomes.svg";
import TreatmentSVG from "../icons/Treatment.svg";
import React from "react";
import {Cross, CrossIcon} from "lucide-react";
interface DisplayMenuProps {
  setDisplayValue: (val: number | null) => void;
  displayValue: number;
  setCentersCheck: (val: boolean) => void;
  centersCheck: boolean;
  clear: boolean;
  setClear: (val: boolean) => void;
  clearClickable: boolean;
  setIsFiltersOpen?: () => void;
  showCentersCheckbox?: boolean;
}
const DisplayMenu: React.FC<DisplayMenuProps> = ({
  displayValue,
  setCentersCheck,
  centersCheck,
  setDisplayValue,
  clear,
  setClear,
  clearClickable,
  setIsFiltersOpen,
  showCentersCheckbox = true,
}) => {
  return (
    <>
      <div className="bg-valmainheart lg:rounded-xl flex-col items-start w-full justify-start lg:min-w-full min-h-screen lg:min-h-0 lg:max-h-[calc(100vh-200px)] xl:h-auto overflow-y-auto pb-8 lg:pb-0 xl:mb-10">
        <div className="lg:hidden mt-4 w-[93%] mx-auto flex justify-between">
          <button
            className="text-[18px] font-bold"
            onClick={() => setIsFiltersOpen?.()}></button>
          <div className="flex items-center">
            {clearClickable && (
              <button
                className="text-[16px] underline"
                onClick={() => {
                  setClear(true);
                  setIsFiltersOpen?.();
                }}>
                Clear All
              </button>
            )}
            <button className="ps-4" onClick={() => setIsFiltersOpen?.()}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
        <div className="px-4 pt-4 mt-6 lg:mt-0 row items-end justify-between hidden lg:flex">
          {" "}
          <div className="text-5xl text-valmidnight font-bold font-caption-1! ml-3">
            {" "}
            Display
          </div>
          {clearClickable ? (
            <button
              className="text-base font-bold text-valmidnight font-caption-1 mb-1 underline"
              onClick={() => {
                setClear(true);
              }}>
              {!clear ? <div>Clear</div> : <div>{""}</div>}
            </button>
          ) : null}
        </div>
        <div className="flex flex-col justify-between h-[calc(100vh-100px)]">
          <div className="my-5 overflow-y-auto lg:overflow-y-visible">
            <div className="collapse collapse-plus rounded-sm text-valmidnight">
              <input type="checkbox" name="my-accordion-1" defaultChecked />
              <div
                className="collapse-title text-xl font-medium"
                style={{position: "static"}}>
                <img
                  className="absolute top-[22px] left-[0px] right-[10px] w-5 h-5 ml-3"
                  alt=""
                  src={EpiSVG}
                />
                <div className="ml-7 text-nowrap">Epidemiology</div>
              </div>
              <div className="collapse-content">
                <p>
                  <EpiMenu
                    setDisplayValue={setDisplayValue}
                    displayValue={displayValue}
                    setClear={setClear}
                    clear={clear}
                    setIsFiltersOpen={setIsFiltersOpen}></EpiMenu>
                </p>
              </div>
            </div>
            <br />
            <div className="collapse collapse-plus  rounded-sm  ">
              <input type="checkbox" name="my-accordion-2" />
              <div
                className="collapse-title text-xl font-medium"
                style={{position: "static"}}>
                <img
                  className="absolute top-[22px] left-[0px] right-[10px] w-5 h-5 ml-3"
                  alt=""
                  src={CliSVG}
                />
                <div className="ml-7 text-nowrap text-valmidnight">
                  {" "}
                  Clinical Characteristics{" "}
                </div>
              </div>
              <div className="collapse-content">
                <p>
                  {" "}
                  <ClinicalMenu
                    setDisplayValue={setDisplayValue}
                    displayValue={displayValue}
                    setClear={setClear}
                    clear={clear}
                    setIsFiltersOpen={setIsFiltersOpen}></ClinicalMenu>
                </p>
              </div>
            </div>
            <br />
            <div className="collapse collapse-plus  rounded-sm ">
              <input type="checkbox" name="my-accordion-3" />
              <div
                className="collapse-title text-xl font-medium"
                style={{position: "static"}}>
                <img
                  className="absolute top-[22px] left-[0px] right-[10px] w-5 h-5 ml-3"
                  alt=""
                  src={TreatmentSVG}
                />
                <div className="ml-7 text-nowrap text-valmidnight">
                  {" "}
                  Treatment{" "}
                </div>
              </div>
              <div className="collapse-content">
                <p>
                  {" "}
                  <TreatmentMenu
                    setDisplayValue={setDisplayValue}
                    displayValue={displayValue}
                    setClear={setClear}
                    clear={clear}
                    setIsFiltersOpen={setIsFiltersOpen}></TreatmentMenu>
                </p>
              </div>
            </div>
            <br />
            <div className="collapse collapse-plus  rounded-sm">
              <input type="checkbox" name="my-accordion-4" />

              <div
                className="collapse-title text-xl font-medium"
                style={{position: "static"}}>
                <img
                  className="absolute top-[22px] left-[0px] right-[10px] w-5 h-5 ml-3"
                  alt=""
                  src={OutcomesSVG}
                />
                <div className="ml-7 text-nowrap text-valmidnight">
                  Clinical Outcomes
                </div>
              </div>
              <div className="collapse-content ">
                <p>
                  {" "}
                  <OutcomesMenu
                    setDisplayValue={setDisplayValue}
                    displayValue={displayValue}
                    setClear={setClear}
                    clear={clear}
                    setIsFiltersOpen={setIsFiltersOpen}
                  />
                </p>
              </div>
            </div>
            <br />
            <div className="collapse collapse-plus  rounded-sm ">
              <input type="checkbox" name="my-accordion-5" />

              <div
                className="collapse-title text-xl font-medium"
                style={{position: "static"}}>
                <img
                  className="absolute top-[22px] left-[0px] right-[10px] w-5 h-5 ml-3"
                  alt=""
                  src={EcoSVG}
                />
                <div className="ml-7 text-nowrap text-valmidnight">
                  {" "}
                  Economic Outcomes{" "}
                </div>
              </div>
              <div className="collapse-content ">
                <p>
                  <EconomicBurdenMenu
                    setDisplayValue={setDisplayValue}
                    displayValue={displayValue}
                    setClear={setClear}
                    clear={clear}
                    setIsFiltersOpen={setIsFiltersOpen}
                  />
                </p>
              </div>
            </div>
            <br />
            <div className="collapse collapse-plus   rounded-sm ">
              <input
                type="checkbox"
                name="my-accordion-6"
                defaultChecked={true}
              />

              <div
                className="collapse-title text-xl font-medium"
                style={{position: "static"}}>
                <img
                  className="absolute top-[22px] left-[0px] right-[10px] w-5 h-5 ml-3"
                  alt=""
                  src={MiscSVG}
                />
                <div className="ml-7 text-nowrap text-valmidnight">
                  {" "}
                  Miscellaneous{" "}
                </div>
              </div>
              <div className="collapse-content ">
                <p>
                  <MiscMenu
                    setDisplayValue={setDisplayValue}
                    displayValue={displayValue}
                    setCentersCheck={setCentersCheck}
                    centersCheck={centersCheck}
                    setClear={setClear}
                    clear={clear}
                    clearClickable={clearClickable}
                    showCentersCheckbox={showCentersCheckbox}
                    setIsFiltersOpen={setIsFiltersOpen}
                  />
                </p>
              </div>
            </div>
            <br />
          </div>
          {/* <div className="sticky bottom-0 left-0 right-0 bg-valmainheart flex flex-wrap justify-between w-full px-4 lg:hidden py-5">
            <button onClick={() => setIsFiltersOpen?.()}>Close</button>
            <button className="text-[18px] font-bold" onClick={() => setIsFiltersOpen?.()}>Apply Filters</button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default DisplayMenu;
